import { render, staticRenderFns } from "./u-card-hover-border-bottom.vue?vue&type=template&id=4edf75a9&scoped=true&"
import script from "./u-card-hover-border-bottom.vue?vue&type=script&lang=js&"
export * from "./u-card-hover-border-bottom.vue?vue&type=script&lang=js&"
import style0 from "./u-card-hover-border-bottom.vue?vue&type=style&index=0&id=4edf75a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edf75a9",
  null
  
)

export default component.exports